// extracted by mini-css-extract-plugin
module.exports = {"inner":"popup_inner_zl7SJ","bg":"popup_bg_13yS9","top":"popup_top_3_nGk","maininner":"popup_maininner_1ILUV","bottom":"popup_bottom_2vFZ8"};